// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__3lRM4","statusContainer":"styles_statusContainer__1jbte","seeDetailButton":"styles_seeDetailButton__2qRZI"};